define('features/overlayGameLauncher/adventureTwo/shop/ShopModel',[
    'underscore'
], function (_) {

    return function AdventureTwoShopModel (ShopItemModel,
                                           shopObservableData) {
        var self = this,
            playerId = shopObservableData.property('playerId');

        self.items = shopObservableData.property('items').pipe(function (rawShopItems) {
            var ShopItem = _.partialConstructor(ShopItemModel, playerId());

            return _.map(rawShopItems, function (data) {
                return new ShopItem(data);
            });
        });

    };

});

